import FadeInImage from 'components/FadeInImage';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import {
  SET_DISPLAY_PROFILE_MODAL,
  SET_PROFILE_LAYOUT_TYPE,
} from '../redux/profile.types';
import { clearProfileForm } from '../redux/profile.actions';

export const AddProfileButton = ({ menuView = false, onClose }) => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const { listProfiles_access_option_button_addProfile } = useSelector(
    state => state.asset,
  );

  const handleAddProfile = () => {
    dispatch({
      type: SET_PROFILE_LAYOUT_TYPE,
      payload: 'CREATE_PROFILE',
    });
    dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: true });
    dispatch(clearProfileForm());
    onClose && onClose();
  };

  return (
    <div className={`profile-avatar ${menuView ? 'menu-view' : ''}`}>
      <button
        className="profile-avatar__img"
        type="button"
        onClick={handleAddProfile}
      >
        <FadeInImage
          imageSrc={listProfiles_access_option_button_addProfile}
          imageAlt={'clarovideo-add-profile'}
          width={160}
          height={160}
          classNames={['clarovideo-add-profile__img__tag-button']}
        />
      </button>
      <span className="profile-avatar__name">
        {translations?.listProfiles_access_addProfile_label}
      </span>
    </div>
  );
};
